export default {
  props: {},
  data: function () {
    return {
      proModules: ["ICD10", "BC", "DZ", "RX"],
      freeModules: ["CL", "MED", "ORAL", "REF", "SITE", "IMG"],

      moduleOptions: {
        ALL: { name: "All Sections", short: "All" },
        ICD10: {
          name: "ICD10 Codes",
          short: "ICD",
          DEFAULT: {
            image: "https://www.eyedock.com/images/menu_icons/icd_icon.svg",
            search: "/icd10/search/",
          },
        },
        BC: {
          name: "Billing Codes",
          short: "Codes",
          DEFAULT: {
            image: "https://www.eyedock.com/images/menu_icons/icd_icon.svg",
          },
        },
        CL: {
          name: "Soft Contact Lenses",
          short: "CLs",
          image: "https://www.eyedock.com/images/menu_icons/scl_icon.svg",
          DEFAULT: {
            image: "https://www.eyedock.com/images/menu_icons/scl_icon.svg",
          },
          PRODUCT: {
            image: "https://www.eyedock.com/images/menu_icons/scl_icon.svg",
          },
          COMPANY: {
            icon: "factory",
            image:
              "https://www.eyedock.com/modules/Lenses/pnimages/comp_logos/",
          },
          COMPONENT: { icon: "flask" },
        },
        RGP: {
          name: "GP & Specialty Lenses",
          short: "GPs",
          DEFAULT: {
            image:
              "https://www.eyedock.com/images/menu_icons/scleral2_icon.svg",
          },
          PRODUCT: {
            image:
              "https://www.eyedock.com/images/menu_icons/scleral2_icon.svg",
          },
        },
        MED: {
          name: "Ophthalmic Medications",
          short: "Meds",
          DEFAULT: {
            image: "https://www.eyedock.com/images/menu_icons/meds_icon.svg",
          },
          PRODUCT: {
            image: "https://www.eyedock.com/images/menu_icons/meds_icon.svg",
          },
          COMPANY: { icon: "factory" },
          COMPONENT: { icon: "flask" },
        },
        ORAL: {
          name: "Oral/Systemic Meds (related to eye care)",
          short: "Orals",
          DEFAULT: { icon: "pill" },
        },
        DZ: {
          name: "Ocular Conditions",
          short: "Dz",
          DEFAULT: { icon: "eye-outline" },
        },
        REF: {
          name: "Clinical References",
          short: "Refs",
          DEFAULT: { icon: "book-open-variant" },
        },
        IMG: {
          name: "Patient Education Images",
          short: "Images",
          DEFAULT: { icon: "image" },
        },

        RX: {
          name: "Refraction / Power",
          short: "Rx",
          DEFAULT: {
            image:
              "https://www.eyedock.com/images/menu_icons/phoropter_icon.svg",
          },
        },
        SITE: {
          name: "EyeDock Features",
          short: "Page",
          DEFAULT: {
            icon: "calculator",
          },
        },
      },

      imagePaths: {
        CL: {
          type: "/images/menu_icons/lensTypes/",
          replace: "/images/menu_icons/replace/",
          PRODUCT:
            "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
          PRIVATE:
            "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
          COMPANY:
            "https://www.eyedock.com/modules/Lenses/pnimages/comp_logos/",
        },
        MED: {
          RX: "/images/menu_icons/meds/small_rx_icon.svg",
          OTC: "/images/menu_icons/meds/small_otc_icon.svg",
          PRODUCT: "https://www.eyedock.com/fdaMeds/media/",
        },
        ORAL: {
          // product: "https://www.eyedock.com/fdaMeds/media/",
        },
        RGP: {
          PRODUCT: "https://www.eyedock.com/images/rgp_media/",
          corneal: "/images/menu_icons/rgp_icon.svg",
          "ortho-k": "/images/menu_icons/ortho_k_icon.svg",
          scleral: "/images/menu_icons/scleral_icon.svg",
        },
        BC: {
          CPT: "/images/menu_icons/cpt_icon.svg",
          EM: "/images/menu_icons/em_icon.svg",
          MOD: "/images/menu_icons/modifier_icon.svg",
        },
        SITE: {
          PRODUCT: "https://www.eyedock.com/",
        },
        IMG: {
          PRODUCT: "https://www.eyedock.com/images/educational_images/",
        },

        MENU: { ICON: "/images/menu_icons/" },
      },
    };
  },
  methods: {
    getDetailPath(obj) {
      if (obj.url) return obj.url;
    },
    pathForModuleProduct(module, type) {
      if (!module) return null;
      if (module == "ORAL") module = "MED";
      let rtn = this.imagePaths[module]?.[type];

      return rtn;
    },
    fullPathForProductImage(module, type, image) {
      if (!module || !image) return null;
      let path = this.pathForModuleProduct(module, type);
      // console.log(path + image);
      return path ? path + image : image;
    },
    nameForModule(module) {
      let name = this.moduleOptions[module]?.name;
      return name ? name : module;
    },

    // assume data can have keys for "module", "type"
    // for meds:  "group:dosage_form", "group:product_type"

    iconForModuleItem(data) {
      //   console.log(data);
      if (!data) return null;
      let rtn = { icon: null, image: null };
      let module = data.module;
      let type = data.type;

      let obj = this.moduleOptions[module];
      let typeObj = obj?.[type];
      if (typeObj) {
        rtn = typeObj;
      } else if (obj["DEFAULT"]) rtn = obj["DEFAULT"];

      if (!rtn.icon && !rtn.image) {
        if (type == "COMPANY") rtn.icon = "factory";
        if (type == "COMPONENT") rtn.icon = "flask";
      }
      // console.log(rtn);
      return rtn;
    },
    // pathToDetails(data) {},
  },
};
